import { detect } from 'detect-browser';

const browser = detect();
const browserName = browser?.name ?? 'unknown';
const browserVersion = browser?.version ?? 'unknown';
const operatingSystem = browser?.os ?? 'unknown';

const browserDetails = {
  browser: browserName,
  browserVersion,
  operatingSystem,
};

Object.freeze(browserDetails);

export default browserDetails;
